import { FC, useCallback, useState } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import styles from "./style";

import Button from "components/CustomButton";

import { Attribute } from "interfaces/Metadata.interface";

interface AttributesProps {
  attributes: Attribute[] | null;
  gridType?: "2cols"; // Can be potentially expanded in the future
}

const Attributes: FC<AttributesProps> = ({ attributes, gridType }) => {
  const [isExpanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const validAttributes = attributes?.filter(
    (f) => f.trait_type !== "Uniqly" && f.value !== "?" && f.value !== "",
  );

  const handleShowMoreAttributes = useCallback(() => {
    setExpanded((prevState) => !prevState);
  }, []);

  const attributesToShow =
    isExpanded || isDesktop ? validAttributes : validAttributes?.slice(0, 6);

  if (!attributesToShow || attributesToShow.length < 1) {
    return null;
  }

  return (
    <>
      <Typography component="h4" variant="h4" gutterBottom>
        ATTRIBUTES
      </Typography>
      <Box py={1} sx={gridType ? styles[gridType] : styles.box}>
        {attributesToShow.map((attribute, index) => {
          return (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={styles.attribute}
              key={`item-${index}`}
              px={1}
            >
              <Typography
                variant="body2"
                sx={[styles.upperCase, styles.center]}
                gutterBottom
              >
                {attribute.trait_type}
              </Typography>
              <Typography
                component="h5"
                variant="h5"
                color="textPrimary"
                align="center"
                sx={styles.upperCase}
              >
                {attribute.value}
              </Typography>
            </Box>
          );
        })}
      </Box>
      {validAttributes && validAttributes.length > 6 && !isDesktop && (
        <Box display="flex" justifyContent="center" mx="auto" width="30%">
          <Button simple onClick={handleShowMoreAttributes} sx={styles.button}>
            {isExpanded ? (
              <>
                view less
                <KeyboardArrowRightIcon />
              </>
            ) : (
              <>
                view more
                <KeyboardArrowDownIcon />
              </>
            )}
          </Button>
        </Box>
      )}
    </>
  );
};

export default Attributes;
